import { createSystem, defaultConfig } from '@chakra-ui/react';
import { semanticTokens } from './semanticTokens';
import { buttonRecipe } from './recipes/buttonRecipe';
import { cardRecipe } from './recipes/cardRecipe';
import { tableRecipe } from './recipes/tableRecipe';
import { checkboxRecipe } from './recipes/checkboxRecipe';
import { inputRecipe } from './recipes/inputRecipe';
import { selectRecipe } from './recipes/selectRecipe';

export const HEADING_FONT_FAMILY = `Poppins, Arial, sans-serif`;
export const FONT_FAMILY = `Poppins, Arial, sans-serif`;

export const theme = createSystem(defaultConfig, {
	cssVarsPrefix: 'tav',
	globalCss: {
		'html, body, #root': {
			height: '100%',
			scrollBehavior: 'smooth',
		},
		'.react-datepicker-wrapper': {
			width: '100%',
		},
	},
	theme: {
		breakpoints: {
			mobile: '850px',
		},
		tokens: {
			fonts: {
				heading: { value: HEADING_FONT_FAMILY },
				body: { value: FONT_FAMILY },
			},
			colors: {
				brand: {
					primary: {
						500: { value: '#3dd598' }, // base color
						600: { value: '#0a7349' }, // hover color
					},
					secondary: {
						500: { value: '#fbf9ff' }, // base color
						600: { value: '#ededed' }, // hover color
					},
				},
			},
		},
		slotRecipes: {
			card: cardRecipe,
			table: tableRecipe,
			checkbox: checkboxRecipe,
			select: selectRecipe,
		},
		recipes: {
			button: buttonRecipe,
			input: inputRecipe,
		},

		semanticTokens,
	},
});

export default theme;
